import styled from "styled-components";
import { BackToTopPageButton } from "../../molecules/BackToTopPageButton";

export const PrivacyPolicy: React.FC = () => {
  return (
    <Container>
      <TitleWrapper>個人情報保護方針</TitleWrapper>
      <CaptionArea>
        <p>
          当社は、高度情報通信社会における個人情報保護の重要性を認識し、以下の方針に基づき個人情報の保護に努めます。
        </p>
      </CaptionArea>
      <CaptionArea>
        <p>
          当社のウェブサイトは、SSLセキュリティにより高度に保護されています。個人情報がご本人の同意なく外部にわたることは一切ありません。
        </p>
      </CaptionArea>

      <Article>
        <ArticleHeader>個人情報の取得について</ArticleHeader>
        <ArticleContent>
          <p>
            当社は、お客様から個人情報の提供を受ける場合は、その利用目的が明らかな場合を除き、ご提供いただく個人情報の利用目的を明示いたします。
          </p>
        </ArticleContent>
      </Article>

      <Article>
        <ArticleHeader>個人情報の利用について</ArticleHeader>
        <ArticleContent>
          <p>
            お客様からご提供いただきました個人情報につきましては、利用目的の範囲内で利用いたします。
          </p>
        </ArticleContent>
      </Article>

      <Article>
        <ArticleHeader>個人情報の第三者提供について</ArticleHeader>
        <ArticleContent>
          <p>
            お客様からご提供いただきました個人情報につきましては、以下のいずれかに該当する場合を除き、第三者へは提供いたしません。
          </p>

          <BulletPoints>
            <p className="bullet-point">お客様の同意がある場合</p>
            <p className="bullet-point">
              当社に対して守秘義務を負う業務委託先に、利用目的の範囲内で業務を委託する場合
            </p>
            <p className="bullet-point">
              統計処理を施し、お客様個人の情報を識別できないようにした場合
            </p>
            <p className="bullet-point">
              法令に基づき、個人情報の開示が求められた場合
            </p>
          </BulletPoints>
        </ArticleContent>
      </Article>

      <Article>
        <ArticleHeader>個人情報の管理について</ArticleHeader>
        <ArticleContent>
          <p>
            当社は、個人情報の改ざん、漏えい、不正な浸入などを防止するため、可能な限り必要な諸施策を講じます。
          </p>
        </ArticleContent>
      </Article>

      <Article>
        <ArticleHeader>
          個人情報の開示・訂正・利用停止・消去について
        </ArticleHeader>
        <ArticleContent>
          <p>
            お客様の個人情報に関する開示・訂正・利用停止・消去のご要望につきましては、「お客様ご意見窓口」にご連絡ください。
          </p>
        </ArticleContent>
      </Article>

      <Article>
        <ArticleHeader>クッキーについて</ArticleHeader>
        <ArticleContent>
          <p>
            本サイトは効率的にご利用いただけるよう、お客様のコンピュータを識別する「クッキー(Cookie)」と呼ばれる技術を使用したページがあります。お客様はブラウザの設定によりクッキーの警告を表示させたり、機能を無効にしたりできますが、無効にした結果、サービスの一部または全部が制限される場合があります。
          </p>
        </ArticleContent>
      </Article>

      <Article>
        <ArticleHeader>改訂について</ArticleHeader>
        <ArticleContent>
          <p>
            当社は、個人情報保護のため、もしくは法令その他の規範の変更に対応するため、プライバシーポリシーの一部を改訂する場合があります。
          </p>
        </ArticleContent>
      </Article>

      <Article>
        <ArticleHeader>お客様ご意見窓口</ArticleHeader>
        <ArticleContent>
          <p>
            当社への個人情報保護に関するご質問は、こちらへお問合せください。
          </p>
        </ArticleContent>
      </Article>

      <FooterNoteArea>
        <p>[株式会社ジョイフル お客様ご意見窓口]</p>
        <InfoContainer>
          <span>Tel.</span>
          <span className="tel">097-551-7131</span>
          <span>(代表)</span>
        </InfoContainer>
        <InfoContainer>
          <span>Fax.</span>
          <span className="tel">097-551-7369</span>
        </InfoContainer>
        <p>受付時間：月曜〜金曜&nbsp;&nbsp;&nbsp;9時30分〜18時30分</p>
      </FooterNoteArea>

      <FooterArea>
        <p className="date">平成22年12月16日改定</p>
      </FooterArea>

      <ButtonWrapper>
        <BackToTopPageButton />
      </ButtonWrapper>
    </Container>
  );
};

const Container = styled.div`
  padding: 0 16px 61px;
  color: #333333;
`;

const TitleWrapper = styled.p`
  font-size: 20px;
  font-weight: 500;
  line-height: 1;
  padding: 43px 0 28px 0;
  display: flex;
  font-family: "Hiragino Sans";
  justify-content: center;
`;

const Article = styled.div`
  margin-top: 34px;
`;

const ArticleHeader = styled.p`
  font-size: 14px;
  font-weight: 500;
  line-height: 26px;
  border-bottom: 1px solid #000;
  margin: 8px 0 10px 0;
  font-family: "Hiragino Sans";
`;

const CaptionArea = styled.div`
  position: relative;
  font-size: 14px;
  font-weight: 200;
  line-height: 21px;
  margin-bottom: 34px;
  p {
    font-family: "Hiragino Sans";
  }
`;

const ArticleContent = styled.div`
  line-height: 21px;
  font-size: 14px;
  font-weight: 200;
  p {
    font-family: "Hiragino Sans";
  }
`;

const BulletPoints = styled.div`
  padding-top: 4px;

  .bullet-point {
    position: relative;
    padding-left: 19px;
    line-height: 26px;

    &:before {
      content: "";
      position: absolute;
      width: 12px;
      height: 12px;
      background: #333333;
      border-radius: 100%;
      left: 0px;
      top: 7px;
    }
  }
`;

const FooterNoteArea = styled.div`
  text-align: left;

  p {
    line-height: 36px;
    font-size: 14px;
    margin-top: 10px;
    font-weight: 200;
    font-family: "Hiragino Sans";
  }

  .tel {
    font-size: 20px;
    padding: 0 12px;
    font-family: "Hiragino Sans";
  }
`;

const InfoContainer = styled.div`
  margin: 0;
  font-size: 14px;
  font-weight: 300;
  padding: 10px 0 0;
  span {
    font-family: "Hiragino Sans";
  }
`;

const FooterArea = styled.div`
  text-align: right;
  margin-top: 56px;
  margin-bottom: 38px;

  p {
    font-family: "Hiragino Sans";
    font-weight: 300;
    font-size: 14px;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  button {
    line-height: 1;
    height: auto;
    font-weight: 600;
    font-family: "Hiragino Sans";
  }
`;
